module.exports = __webpack_public_path__ + "static/food-99880b7ebbb1f034d24398d0f8bf29ea.jpg";